import MainSection from "./components/MainSection";
import { read_cookie } from "sfcookies";
import React, { useEffect, useState } from "react";
import Login from "./components/auth/Login";
import PasswordReset from "./components/auth/PasswordReset";
import { CircularProgress } from "@mui/material";
import { SET_PASSWORD_PATH } from "./utils/constants";

function App () {
    const [loading, setLoading] = useState( true );
    const [logged, setLogged] = useState( false );

    useEffect( () => {
        if ( read_cookie( 'inventory-tkn' ).length > 0 ) {
            setLogged( true );
        } else {
            setLogged( false );
        }
        setLoading( false );
    }, [] );

    if ( loading ) return (
        <div className="d-flex justify-content-center align-content-center align-items-center">
            <CircularProgress />
        </div>
    );

    // Link de activación o recuperación: se muestra aunque haya una sesión abierta en el navegador
    if ( window.location.pathname === SET_PASSWORD_PATH ) {
        return <PasswordReset />;
    }

    if ( !logged ){
        return (
            <Login />
        );
    }
    return <MainSection/>;
}

export default App;
